import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { LoanAccountsDetailHoldingsRoute } from './LoanAccountsDetailHoldingsRoute';
import { LoanAccountsDetailsOverviewRouter } from './LoanAccountsDetailOverviewRoute';
import { LoanAccountsOverviewRouter } from './LoanAccountsOverviewRoute';
import { LoanAccountsOverviewUnderMarginReportRouter } from './LoanAccountsOverviewUnderMarginReportRoute';
import { ValleyBankTemplate } from 'valleyBank/domains/page/ui/ValleyBankTemplate';

export const LoanAccountsRouter = () => {
  return (
    <ValleyBankTemplate canToggleDataSource>
      {/* Paths relative to "/valley-bank/loan-accounts/*" */}
      <Routes>
        <Route path="/" element={<LoanAccountsOverviewRouter />} />
        <Route
          path="/under-margin-report"
          element={<LoanAccountsOverviewUnderMarginReportRouter />}
        />
        <Route
          path="/summary"
          element={<LoanAccountsDetailsOverviewRouter />}
        />
        <Route path="/holdings" element={<LoanAccountsDetailHoldingsRoute />} />
      </Routes>
    </ValleyBankTemplate>
  );
};
